import React, { useEffect } from 'react';

import queryString from 'query-string';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { gameShiftsActions } from '../../../redux/ducks/gameShifts';
import { commonMessages } from '../../../utility/commonMessages';
import Scoreboard from '../../components/scoreboard';

import ShiftChartContainer from './components/shiftChartContainer';

import './styles';

const ShiftCharts = () => {
    const dispatch = useDispatch();
    const { game, teamData, shifts, loadingState } = useSelector(({ gameShifts }) => gameShifts);

    useEffect(() => {
        const queryParams = queryString.parse(window.location.search);
        const gameId = { gameId: queryParams.id };
        dispatch(gameShiftsActions.requestGameShifts(gameId));
    }, []);

    return (
        <LoadingDisplay isLoading={!loadingState.hasLoaded}>
            {shifts.length === 0 ? (
                <div className="noData">
                    <FormattedMessage {...commonMessages.misc.noData} />
                </div>
            ) : (
                <>
                    <Scoreboard game={game} teamData={teamData} />
                    <ShiftChartContainer />
                </>
            )}
        </LoadingDisplay>
    );
};

export { ShiftCharts as Component };
